const SENTENCE_SPLIT = /(?<=[.!?])\s+(?=[A-Z])/;

/**
 * Email drafts need blank lines between short paragraphs so markdownToHtml
 * and whitespace-pre-wrap both render naturally. SMS stays as-is.
 */
export function ensureOutreachParagraphs(body: string): string {
  const trimmed = body.replace(/\r\n/g, "\n").trim();
  if (!trimmed) return trimmed;
  if (/\n\s*\n/.test(trimmed)) {
    return trimmed.replace(/\n{3,}/g, "\n\n");
  }
  const lines = trimmed
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);
  if (lines.length >= 2) return lines.join("\n\n");

  const sentences = trimmed
    .split(SENTENCE_SPLIT)
    .map((sentence) => sentence.trim())
    .filter(Boolean);
  if (sentences.length < 3) return trimmed;

  const paragraphs: string[] = [];
  for (let i = 0; i < sentences.length; i += 2) {
    paragraphs.push(sentences.slice(i, i + 2).join(" "));
  }
  return paragraphs.join("\n\n");
}
